import React from 'react';
import { useTitle } from "fearless-common-ui";
import Button from "react-bootstrap/Button";
import {concepts, SignUpCode} from "fearless-common";
import {PlusLg} from "react-bootstrap-icons";
import {adminRoutes} from "../../utils/routes";
import Pages from "../../components/layout/Pages";
import OrderableTable from "../../components/layout/OrderableTable";
import {backendEndpoints} from "../../libs/backendEndpoints";
import Description from "../../components/Description";
import {ColumnDef} from "@tanstack/react-table";

const columns: ColumnDef<SignUpCode>[] = [
    { id: 'code', accessorKey: 'code', header: 'Code' },
    { id: 'valid_until', accessorKey: 'valid_until', header: 'Valid until' },
    { id: 'title', accessorKey: 'title', header: 'Title' },
];

/**
 * Show a table of all institutes.
 */
export default function AdminSignUpCodes() {
    useTitle(`Admin Sign up codes`);
    return (
        <Pages.Centred padded>
            <div className="d-inline-flex align-items-center gap-4">
              <h1>{concepts.SignUpCodes}</h1>
              <Button size="sm" href={adminRoutes.addSignUpCode} variant="outline-primary"><PlusLg /> add</Button>
            </div>
            <Description className="neutral-500">

            </Description>
            <OrderableTable<SignUpCode>
                baseEndpoint={backendEndpoints.getAdminSignUpCodes}
                memoisedColumns={columns}
                buildLink={(record) => adminRoutes.signUpCode(record.id)}
            />
        </Pages.Centred>
    );
}
